import React, { Component } from "react";
import { Container, Col, Row, Card, Button, Modal } from "react-bootstrap";
import cinstance from "../../Service/randomcinstance";
import web3 from "../../Service/web3";
import axios from "axios";
import NavBar from "../../Components/NavBar";
import ListCard from "../../Components/ListCard";
import FAQ from "../../Components/FAQ";
import Banner from "../../Components/Banner";
import { Path } from "../../../static/Constants";
import moment from "moment";
class Alllottery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seed: "",
      loading: true,
      Randomresult: "",
      winner: "",
      lotterylist: [],
      partnerlists: [],
      partnerLogoData: [],
      show: false,
    };
  }
  async componentDidMount() {
    try {
      if (window.ethereum) {
        window.web3 = web3;
      }

      const totalIds = Number(await cinstance.methods.lotteryId().call());
      const lotteryCalls = [];

      console.log("totalIds", totalIds);
      for (let i = 1; i <= totalIds; i++) {
        lotteryCalls.push(
          cinstance.methods
            .lottery(i)
            .call()
            .catch((err) => {
              console.log("lottery", i, err);
              return null;
            })
        );
      }

      const lotteryResults = await Promise.all(lotteryCalls);
      const lotterylist = lotteryResults
        .filter(
          (lottery) =>
            lottery &&
            (lottery.status === "0" ||
              lottery.status === "3" ||
              lottery.status === "5") &&
            Number(lottery.lotteryType) === 2
        )
        .sort((a, b) => Number(b.lotteryId) - Number(a.lotteryId));

      const uniquePartnerAddresses = [
        ...new Set(
          lotterylist
            .map((lottery) => lottery.partnerAddress)
            .filter(Boolean)
        ),
      ];

      const partnerResults = await Promise.all(
        uniquePartnerAddresses.map((address) =>
          cinstance.methods
            .partnerbyaddr(address)
            .call()
            .catch((err) => {
              console.log("partner", address, err);
              return null;
            })
        )
      );

      const partnerlists = partnerResults.filter(Boolean);

      this.setState({ lotterylist, partnerlists, loading: false });
    } catch (err) {
      console.log("Alllottery load error", err);
      this.setState({ loading: false });
    }

    const apiUrl = process.env.REACT_APP_API_KEY;

    if (apiUrl) {
      axios
        .get(`${apiUrl}/s3imageupload/getAllPartnerLogos`)
        .then((response) => {
          this.setState({ partnerLogoData: response.data.result || [] });
        })
        .catch(() => {
          this.setState({ partnerLogoData: [] });
        });
    }

 
  }

  render() {
    const { lotterylist, partnerlists, partnerLogoData, loading } = this.state;
    const sortedLotteryList = [...lotterylist].sort(
      (a, b) => Number(b.lotteryId) - Number(a.lotteryId)
    );

    const findPartnerByAddress = (address, partnerList) => {
      return (
        partnerList?.find((partner) => partner.partnerAddress === address) || {}
      );
    };

    return (
      <div fluid className="p-0 m-0 allLottery">
        <NavBar />

        <Container>
          <div className="mx-auto mt-3 ">
            <Row className="lottery-section">
              <Col>
                <h2
                  className="section-title"
                  style={{ fontWeight: "600", fontSize: "28px" }}
                >
                  Autobet MRL
                </h2>
              </Col>
            </Row>
            <Row className="mx-auto lottery-section2 text-center">
              {loading && <h4 className="spacingleft">Loading lotteries...</h4>}
              {!loading && lotterylist.length === 0 && (
                <h4 className="spacingleft">No Active Lotteries !</h4>
              )}
              {sortedLotteryList.map((item, index) => {
                const partnerData = findPartnerByAddress(
                  item.partnerAddress,
                  partnerlists
                );
                return (
                  <Col lg={4} key={item.lotteryId || index}>
                    <ListCard
                      history={this.props.history}
                      item={item}
                      partner={partnerData}
                      partnerLogo={partnerLogoData}
                    />
                  </Col>
                );
              })}
            </Row>
          </div>
        </Container>
        {/* <FAQ/> */}

        {/* MODAL */}
        <Modal
          className="PopupStyle"
          show={this.state.show}
          centered
          onHide={() => this.setState({ show: false })}
        >
          <Modal.Body>
            <Container>
              <Row>
                <Col lg={12}>
                  <div className="message-text">
                    I will not close if you click outside me. Don't even try to
                    press escape key.
                  </div>
                </Col>
                <Col lg={12} sm={12} xs={12}>
                  <div className="btn-div">
                    <Button
                      className="submit-btn btn1"
                      onClick={() => this.setState({ show: false })}
                    >
                      Close
                    </Button>
                    <Button className="submit-btn" onClick={() => {}}>
                      Understood
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default Alllottery;
